/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 1 hook(s) need dependency review; fix each and remove this directive */
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import SlickGrid from "@CubeComponents/html/SlickGrid1";
import { HeaderWithIcon } from "@CubeComponents/html/SlickGrid1/Formatters/Formatters";
import Text from "@CubeComponents/html/Text/Text";
import React, { useEffect, useState } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { useTranslation } from "@i18n";

/** Both call sites (`UserNameTagComponentWithProvided`, `UserProfileModalHost`) pass exactly these.
 *  `detailsModalHeader` is a plain `string`: one caller supplies a `TranslatedString` (assignable)
 *  and the other the slice's untranslated `groupHeader`. */
type GroupedUsersDetailsModalProps = {
  closeModal: () => void;
  detailsModalHeader?: string;
  ids: string[];
};

const GroupedUsersDetailsModal = ({ closeModal, detailsModalHeader, ids }: GroupedUsersDetailsModalProps) => {
  // Seeded below from `ids`, one `{ id }` per user; the grid resolves the rest from the id.
  const [dataSource, setDataSource] = useState<{ id: string }[]>([]);
  const [modalVisible, setModalVisible] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    setDataSource(ids.map((id: string) => ({ id })));
  }, []);

  const userHeaderRenderer = () => renderToStaticMarkup(<HeaderWithIcon icon="User Profile" label={t("User")} />);
  const [columnDefinitions] = useState([
    {
      field: "id",
      id: "id",
      name: t("User"),
      filterType: "Text",
      clipMode: "EllipsisWithTooltip",
      formatterType: "userTag",
      headerRenderer: userHeaderRenderer,
    },
  ]);

  const content = () => (
    <div className="flex h-full">
      <SlickGrid
        // Columns are built inline here, not through `typedColumns`, so the brand is asserted at the
        // boundary; adding a `typedColumns()` call would emit.
        columnDefinitions={
          columnDefinitions as typeof columnDefinitions & React.ComponentProps<typeof SlickGrid>["columnDefinitions"]
        }
        dataset={dataSource}
        disableMenuOptions
        disableCheckBoxSelection
        enableSearchBar={false}
      />
    </div>
  );

  const onCancel = () => {
    setModalVisible(false);
    closeModal();
  };

  return (
    <ModalStateDialogComponent
      onCancel={onCancel}
      headerTitle={<Text>{detailsModalHeader}</Text>}
      isVisible={modalVisible}
      modelContent={content()}
      width="23.125rem"
      height="35rem"
    />
  );
};

export default GroupedUsersDetailsModal;
